//common
import './common';

//components
import './blocks/partners-ajax'


addEventListener('ajax:update-complete', (e) => {
    document.querySelector('.wraper-list').classList.remove('_preloader');
})

addEventListener('ajax:before-send', (e) => {
    document.querySelector('.wraper-list').classList.add('_preloader');
})